import * as PIXI from 'pixi.js';

/**
 * FurnitureManager - Gestionnaire de mobilier isométrique à 4 faces
 * Charge les spritesheets et place les meubles sur la grille
 */

// Orientations disponibles pour les sprites 4 faces
const ORIENTATIONS = ['north-west', 'north-east', 'south-east', 'south-west'];

// Définition de tous les meubles disponibles
const FURNITURE_DEFINITIONS = {
  // Postes de travail
  cubicle: {
    spriteSheet: './assets/isometric-sprite/Office_Cubicle_Light_01.png',
    frames: 4,
    scale: 1.0,
    anchor: { x: 0.5, y: 1.0 },
    zOffset: 0
  },
  table_brown_2x2: {
    spriteSheet: './assets/isometric-sprite/Office_Table_Brown_2x2_01.png',
    frames: 4,
    scale: 1.0,
    anchor: { x: 0.5, y: 1.0 },
    zOffset: 0
  },
  chair_black: {
    spriteSheet: './assets/isometric-sprite/Office_Chair_Black_01.png',
    frames: 4,
    scale: 0.8,
    anchor: { x: 0.5, y: 1.0 },
    zOffset: 2 // Légèrement devant la table
  },

  // Zone détente
  couch_brown: {
    spriteSheet: './assets/isometric-sprite/Office_Couch_Brown_02.png',
    frames: 4,
    scale: 1.0,
    anchor: { x: 0.5, y: 1.0 },
    zOffset: 0
  },
  table_coffee_brown: {
    spriteSheet: './assets/isometric-sprite/Office_Table_Coffee_03_Brown.png',
    frames: 4,
    scale: 0.9,
    anchor: { x: 0.5, y: 1.0 },
    zOffset: 0
  },
  coffee_machine: {
    spriteSheet: './assets/isometric-sprite/Office_Misc_Coffee_Machine_04.png',
    frames: 4,
    scale: 0.7,
    anchor: { x: 0.5, y: 1.0 },
    zOffset: 0
  },

  // Équipements
  printer: {
    spriteSheet: './assets/isometric-sprite/Office_Misc_Printer.png',
    frames: 4,
    scale: 0.7,
    anchor: { x: 0.5, y: 1.0 },
    zOffset: 0
  },
  fax: {
    spriteSheet: './assets/isometric-sprite/Office_Misc_Fax.png',
    frames: 4,
    scale: 0.6,
    anchor: { x: 0.5, y: 1.0 },
    zOffset: 0
  },
  cabinet_01: {
    spriteSheet: './assets/isometric-sprite/Office_Misc_Cabinet_01.png',
    frames: 4,
    scale: 0.8,
    anchor: { x: 0.5, y: 1.0 },
    zOffset: 0
  },

  // Décoration
  plant_03: {
    spriteSheet: './assets/isometric-sprite/Office_Misc_Plant_03.png',
    frames: 4,
    scale: 0.8,
    anchor: { x: 0.5, y: 1.0 },
    zOffset: 0
  },
  trashcan: {
    spriteSheet: './assets/isometric-sprite/Office_Misc_Trashcan_Small_03.png',
    frames: 4,
    scale: 0.5,
    anchor: { x: 0.5, y: 1.0 },
    zOffset: 0
  },
  whiteboard: {
    spriteSheet: './assets/isometric-sprite/Office_Misc_Whiteboard_01.png',
    frames: 4,
    scale: 0.9,
    anchor: { x: 0.5, y: 1.0 },
    zOffset: 0
  },
  
  // Accessoires de bureau
  coffee_mug: {
    spriteSheet: './assets/isometric-sprite/Office_Misc_Coffee_Mug.png',
    frames: 4,
    scale: 0.3,
    anchor: { x: 0.5, y: 1.0 },
    zOffset: 5
  },
  notebook: {
    spriteSheet: './assets/isometric-sprite/Office_Misc_Notebook.png',
    frames: 4,
    scale: 0.3,
    anchor: { x: 0.5, y: 1.0 },
    zOffset: 5
  },
  phone: {
    spriteSheet: './assets/isometric-sprite/Office_Misc_Phone.png',
    frames: 4,
    scale: 0.3,
    anchor: { x: 0.5, y: 1.0 },
    zOffset: 5
  },
  notepad: {
    spriteSheet: './assets/isometric-sprite/Office_Misc_Notepad.png',
    frames: 4,
    scale: 0.3,
    anchor: { x: 0.5, y: 1.0 },
    zOffset: 5
  },
  organizer: {
    spriteSheet: './assets/isometric-sprite/Office_Misc_Organizer.png',
    frames: 4,
    scale: 0.3,
    anchor: { x: 0.5, y: 1.0 },
    zOffset: 5
  },
  pc_01: {
    spriteSheet: './assets/isometric-sprite/Office_Misc_PC_01.png',
    frames: 4,
    scale: 0.3,
    anchor: { x: 0.5, y: 1.0}, 
    zOffeset: 5
  },
  pc_02: {
   spriteSheet: './assets/isometric-sprite/Office_Misc_PC_02.png',
   frames: 4,
   scale: 0.3,
   anchor: { x: 0.5, y: 1.0},
   zOffeset: 5
  },
  // Autres tables
  table_brown_2x1: {
    spriteSheet: './assets/isometric-sprite/Office_Table_Brown_2x1_02.png',
    frames: 4,
    scale: 0.9,
    anchor: { x: 0.5, y: 1.0 },
    zOffset: 0
  },
  table_coffee_black: {
    spriteSheet: './assets/isometric-sprite/Office_Table_Coffee_01_Black.png',
    frames: 4,
    scale: 0.9,
    anchor: { x: 0.5, y: 1.0 },
    zOffset: 0
  },
  
  // Autres chaises
  chair_black_02: {
    spriteSheet: './assets/isometric-sprite/Office_Chair_Black_02.png',
    frames: 4,
    scale: 0.8,
    anchor: { x: 0.5, y: 1.0 },
    zOffset: 2
  },
  chair_brown: {
    spriteSheet: './assets/isometric-sprite/Office_Chair_Brown_01.png',
    frames: 4,
    scale: 0.8,
    anchor: { x: 0.5, y: 1.0 },
    zOffset: 2
  },
  
  // Autres éléments
  door: {
    spriteSheet: './assets/isometric-sprite/Office_Misc_Door_02.png',
    frames: 4,
    scale: 1.0,
    anchor: { x: 0.5, y: 1.0 },
    zOffset: 0
  },
  recycle_bin: {
    spriteSheet: './assets/isometric-sprite/Office_Misc_Traschcan_Recycle_Green.png',
    frames: 4,
    scale: 0.6,
    anchor: { x: 0.5, y: 1.0 },
    zOffset: 0
  },
  tv_stand: {
    spriteSheet: './assets/isometric-sprite/Office_Misc_TV_Stand_02.png',
    frames: 4,
    scale: 0.9,
    anchor: { x: 0.5, y: 1.0 },
    zOffset: 0
  },
  tv_wall: {
    spriteSheet: './assets/isometric-sprite/Office_Misc_TV_Wall_02.png',
    frames: 4,
    scale: 0.8,
    anchor: { x: 0.5, y: 1.0 },
    zOffset: 0
  },
  wall_graph: {
    spriteSheet: './assets/isometric-sprite/Office_Misc_Wall_Graph.png',
    frames: 4,
    scale: 0.8,
    anchor: { x: 0.5, y: 1.0 },
    zOffset: 0
  },
  cabinet_02: {
    spriteSheet: './assets/isometric-sprite/Office_Misc_Cabinet_02.png',
    frames: 4,
    scale: 0.8,
    anchor: { x: 0.5, y: 1.0 },
    zOffset: 0
  }
};

/**
 * FurnitureManager - Gère le chargement et le placement du mobilier
 */
export class FurnitureManager {
  constructor(tileWidth, tileHeight, parentContainer = null) {
    this.tileWidth = tileWidth;
    this.tileHeight = tileHeight;
    this.textures = {}; // { furnitureType: { orientation: texture } }
    this.loaded = false;
    // Si un conteneur parent est fourni, utiliser celui-ci, sinon créer un nouveau
    this.furnitureContainer = parentContainer || new PIXI.Container();
    this.furnitureItems = []; // Pour le z-sorting
    this.externalContainer = parentContainer !== null; // Indique si on utilise un conteneur externe
  }

  /**
   * Charge tous les spritesheets et découpe les frames
   */
  async loadAll() {
    console.log('[FurnitureManager] Chargement des meubles...');
    
    const loadPromises = Object.entries(FURNITURE_DEFINITIONS).map(async ([type, config]) => {
      try {
        const sheetTexture = await PIXI.Assets.load(config.spriteSheet);
        this.textures[type] = this.extractFrames(sheetTexture, config.frames);
        console.log(`[FurnitureManager] ✓ ${type} chargé`);
      } catch (error) {
        console.warn(`[FurnitureManager] ✗ Échec chargement ${type}:`, error);
        this.textures[type] = null;
      }
    });
    
    await Promise.all(loadPromises);
    this.loaded = true;
    console.log('[FurnitureManager] Tous les meubles sont chargés');
  }

  /**
   * Extrait les 4 frames d'un spritesheet horizontal
   */
  extractFrames(sheetTexture, frameCount) {
    const frames = {};
    const frameWidth = sheetTexture.width / frameCount;
    const frameHeight = sheetTexture.height;
    
    for (let i = 0; i < frameCount && i < ORIENTATIONS.length; i++) {
      const frame = new PIXI.Texture(
        sheetTexture.baseTexture,
        new PIXI.Rectangle(i * frameWidth, 0, frameWidth, frameHeight)
      );
      frames[ORIENTATIONS[i]] = frame;
    }
    
    return frames;
  }

  /**
   * Place un meuble sur la grille
   * @param {string} type - Type de meuble
   * @param {number} gridX - Position X sur la grille
   * @param {number} gridY - Position Y sur la grille
   * @param {string} orientation - Orientation (north-west, north-east, south-east, south-west)
   * @param {Object} options - Options supplémentaires (offsetX, offsetY, customScale)
   * @returns {PIXI.Container} Le container du meuble placé
   */
  place(type, gridX, gridY, orientation = 'south-east', options = {}) {
    const config = FURNITURE_DEFINITIONS[type];
    if (!config) {
      console.warn(`[FurnitureManager] Type de meuble inconnu: ${type}`);
      return null;
    }

    const textures = this.textures[type];
    if (!textures || !textures[orientation]) {
      console.warn(`[FurnitureManager] Texture non disponible pour ${type}/${orientation}`);
      return this.createFallbackSprite(type, gridX, gridY, config);
    }

    // Calcul de la position à l'écran
    const screenPos = this.gridToScreen(gridX, gridY);
    
    // Création du container
    const container = new PIXI.Container();
    container.position.set(
      screenPos.x + (options.offsetX || 0),
      screenPos.y + (options.offsetY || 0) - (config.zOffset || 0)
    );

    // Création du sprite
    const sprite = new PIXI.Sprite(textures[orientation]);
    sprite.anchor.set(config.anchor.x, config.anchor.y);
    
    // Application de l'échelle
    const scale = options.customScale || config.scale || 1.0;
    const targetWidth = this.tileWidth * scale;
    const actualScale = targetWidth / sprite.texture.width;
    sprite.scale.set(actualScale);

    container.addChild(sprite);

    // Stockage des métadonnées pour le z-sorting
    container.gridX = gridX;
    container.gridY = gridY;
    container.furnitureType = type;
    container.zOffset = config.zOffset || 0;

    // CALCUL DU ZINDEX : (x + y) * 10 + zOffset
    // Les objets avec zOffset plus grand apparaissent au-dessus
    const zOffset = options.zOffset !== undefined ? options.zOffset : (config.zOffset || 0);
    container.zIndex = Math.round((gridX + gridY) * 10 + zOffset);

    // Ajout au container principal
    this.furnitureContainer.addChild(container);
    this.furnitureItems.push(container);

    return container;
  }

  /**
   * Crée un sprite de fallback si le texture n'est pas disponible
   */
  createFallbackSprite(type, gridX, gridY, config) {
    const screenPos = this.gridToScreen(gridX, gridY);
    const container = new PIXI.Container();
    container.position.set(screenPos.x, screenPos.y);

    const graphics = new PIXI.Graphics();
    const color = this.getFallbackColor(type);
    
    // Dessine un cube coloré comme fallback
    const w = this.tileWidth * 0.6;
    const h = this.tileHeight * 0.6;
    const height = 20;

    // Face du haut
    graphics.beginFill(color);
    graphics.moveTo(0, -h);
    graphics.lineTo(w/2, 0);
    graphics.lineTo(0, h);
    graphics.lineTo(-w/2, 0);
    graphics.closePath();
    graphics.endFill();

    // Face droite
    graphics.beginFill(this.darkenColor(color, 0.8));
    graphics.moveTo(w/2, 0);
    graphics.lineTo(0, h);
    graphics.lineTo(0, h + height);
    graphics.lineTo(w/2, height);
    graphics.closePath();
    graphics.endFill();

    // Face gauche
    graphics.beginFill(this.darkenColor(color, 0.6));
    graphics.moveTo(-w/2, 0);
    graphics.lineTo(0, h);
    graphics.lineTo(0, h + height);
    graphics.lineTo(-w/2, height);
    graphics.closePath();
    graphics.endFill();

    container.addChild(graphics);
    
    container.gridX = gridX;
    container.gridY = gridY;
    container.furnitureType = type;
    
    this.furnitureContainer.addChild(container);
    this.furnitureItems.push(container);
    
    return container;
  }

  /**
   * Convertit les coordonnées de grille en coordonnées écran
   */
  gridToScreen(gridX, gridY) {
    const screenX = (gridX - gridY) * (this.tileWidth / 2);
    const screenY = (gridX + gridY) * (this.tileHeight / 2);
    return { x: screenX, y: screenY };
  }

  /**
   * Trie les meubles par profondeur (pour l'effet isométrique)
   */
  sortByDepth() {
    this.furnitureContainer.children.sort((a, b) => {
      // Tri isométrique : (x + y) détermine la profondeur
      const depthA = (a.gridX || 0) + (a.gridY || 0);
      const depthB = (b.gridX || 0) + (b.gridY || 0);
      return depthA - depthB;
    });
  }

  /**
   * Obtient la couleur de fallback selon le type de meuble
   */
  getFallbackColor(type) {
    const colors = {
      cubicle: 0xC4A77D,
      table_brown_2x2: 0x8B4513,
      table_brown_2x1: 0x8B4513,
      chair_black: 0x2C2C2C,
      chair_black_02: 0x2C2C2C,
      chair_brown: 0x6B4423,
      couch_brown: 0x8B4513,
      cabinet_01: 0xD4A373,
      cabinet_02: 0xD4A373,
      coffee_machine: 0x2C2C2C,
      printer: 0xE0E0E0,
      fax: 0xE0E0E0,
      plant_03: 0x228B22,
      trashcan: 0x4A4A4A,
      whiteboard: 0xFFFFFF,
      default: 0x808080
    };
    return colors[type] || colors.default;
  }

  /**
   * Assombrit une couleur
   */
  darkenColor(color, factor) {
    const r = Math.floor(((color >> 16) & 0xff) * factor);
    const g = Math.floor(((color >> 8) & 0xff) * factor);
    const b = Math.floor((color & 0xff) * factor);
    return (r << 16) | (g << 8) | b;
  }

  /**
   * Retourne le container principal des meubles
   */
  getContainer() {
    return this.furnitureContainer;
  }

  /**
   * Retourne le layer pour les personnages (devant sol, derrière meubles)
   */
  getCharacterLayer() {
    return this.characterLayer;
  }

  /**
   * Vérifie si les textures sont chargées
   */
  isLoaded() {
    return this.loaded;
  }
}

export default FurnitureManager;
